<div class="aboutUs">
  <div class="container">
    <div class="custom-container">
      <div class="row pt-5">
        <div class="py-5">
          <p class="text-uppercase pt-5"><a class="text-decoration-none hoMe" href="">Home</a> &nbsp;&nbsp;>>
            &nbsp;&nbsp;<span>about us</span></p>
          <h6 class="text-uppercase py-4 desiGnation">about company</h6>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="ourStory">
  <div class="container">
    <div class="custom-container py-5">
      <div data-aos="fade-up" data-aos-duration="900" class="py-4">
        <h6 class="text-white">OUR STORY</h6>
        <p class="m-0">SP Software (P) Limited, a flagship of SP Group, is a leading enterprise business Software and
          Information
          Technology (IT) Services company, providing IT
          Consulting, Technology and Outsourcing Services. Established in 1995, SPSoft is one of the fastest growing IT
          companies in India having a strong strategic
          alliance with leading global companies and has the capability to handle orders of any size.</p>
      </div>
    </div>
  </div>
</div>

<div class="viSion">

  <div class="container">

    <div class="custom-container">

      <div class="row justify-content-center py-5 counterVision">
        <div class="col-md-2 px-1">
          <div class="counter-box mx-auto colored d-block">
            <p class="counter text-center m-0">{{projectCount}}<span>+</span></p>
            <p class="text-center subLabel m-0">Years of Experience</p>
          </div>
        </div>

        <div class="col-md-2 px-1">
          <div class="counter-box mx-auto colored d-block">
            <p class="counter text-center m-0">{{accurateCount}}<span>+</span></p>
            <p class="text-center subLabel m-0">Global Clients</p>
          </div>
        </div>

        <div class="col-md-2 px-1">
          <div class="counter-box mx-auto colored d-block">
            <p class="counter text-center m-0">{{clientCount}}<span>+</span></p>
            <p class="text-center subLabel m-0">Projects</p>
          </div>
        </div>

        <div class="col-md-2 px-1">
          <div class="counter-box mx-auto colored d-block">
            <p class="counter text-center m-0">{{customerFeedback}}<span>+</span></p>
            <p class="text-center subLabel m-0">Expert Developers</p>
          </div>
        </div>

        <div class="col-md-2 px-1">
          <div class="counter-box mx-auto colored d-block">
            <p class="counter text-center m-0">{{countries}}<span>+</span></p>
            <p class="text-center subLabel m-0">Countries</p>
          </div>
        </div>

      </div>

      <div class="py-5">

        <div class="row pb-4">
          <div class="col-lg-8 mt-5 mb-4 d-flex p-5 vissionEye" data-aos="fade-up" data-aos-duration="1000">
            <div class="col-8">
              <h6 class="m-0 pb-4">Vision</h6>
              <p class="pe-3"><i>To exceed the expectation of our customers by providing value to our customers with
                  quality as the driving principle in products, services & relationships.</i></p>
            </div>
            <div class="col-4 my-auto">
              <img class="img-fluid pb-1" src="../../assets/images/vissioneye.png" alt="vission">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 mt-5 mb-5 offset-lg-4 d-flex p-5 vissionEye" data-aos="fade-up" data-aos-duration="1000">
            <div class="col-8">
              <h6 class="m-0 pb-4">Mission</h6>
              <p class="pe-3"><i>To provide integrated, cost-effective, state-of-the-art, quality solutions for utmost
                  customer satisfaction.</i></p>
            </div>
            <div class="col-4 my-auto">
              <img class="img-fluid pb-1" src="../../assets/images/mission.png" alt="vission">
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>

<div class="whatWeDo">
  <div class="container">
    <div class="custom-container">
      <div class="row serVicesdesc p-5">
        <h6 class="text-center text-uppercase m-0 py-4 pt-4">what we do</h6>
        <p class="text-center m-0 pb-4">We offer varied services like Software Development, Data Analytics, AI
          Solutions, Cloud-based Application
          Development, Manufacturing Automation Development, Mobile Application Development and Telecom Testing
          Services.</p>
      </div>
    </div>
  </div>
</div>

<div class="WhySpsoft py-5">
  <div class="container pt-5">
    <div class="custom-container">
      <div class="row justify-content-start">
        <div class="col-lg-10" data-aos="fade-up" data-aos-duration="800">
          <h6 class="text-uppercase m-0 pt-0 py-3 text-white">why spsoft?</h6>
          <p class="m-0 spsoftDesc pb-5">SPSoft designs and deploys digital solutions for our clients at scale to
            modernize the way they use technology to deliver better business outcomes.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid whySpsoftDetail">

    <div class="row">

      <div class="col-lg-6 px-0" data-aos="fade-right" data-aos-duration="900">
        <img class="img-fluid" src="../../assets/images/whyspsoft.png" alt="whySpsoft">
      </div>

      <div class="col-lg-6 px-4 my-auto flexiBilityList overflow-hidden">

        <div class="detailList w-75">
          <div data-aos="fade-left" data-aos-duration="1000">
            <p class="m-0 text-uppercase">flexibility</p>
            <h6 class="py-2">Flexibility to adopt requirements and <br /> allocate work efficiently</h6>
          </div>
        </div>

        <div class="detailList w-75">
          <div data-aos="fade-left" data-aos-duration="1200">

            <p class="m-0 text-uppercase pt-3">collaboration</p>
            <h6 class="py-2">Timely collaboration to import <br /> performance outcomes</h6>
          </div>
        </div>

        <div class="detailList w-75">
          <div data-aos="fade-left" data-aos-duration="1400">

            <p class="m-0 text-uppercase pt-3">visibility</p>
            <h6 class="py-2">Visibility into delivery activity, proactive <br /> alerts and key metrics</h6>
          </div>
        </div>

        <!-- <div class="detailList w-75 border-0">
          <div data-aos="fade-left" data-aos-duration="1600">

            <p class="m-0 text-uppercase pt-3">flexibility</p>
            <h6 class="py-2">Flexibility to adopt requirements and <br /> allocate work efficiently</h6>
          </div>
        </div> -->

        <div class="detailList w-75 border-0">
          <div data-aos="fade-left" data-aos-duration="1600">
            <p class="m-0 text-uppercase pt-3">Insight</p>
            <h6 class="py-2">Deeper insight to drive business outcomes</h6>
          </div>
        </div>

        <div class="d-flex justify-content-start py-4 flexBtnhide" data-aos="fade-left" data-aos-duration="1800">
          <a href="#" class="customBtn text-decoration-none px-5" role="button">Explore More...</a>
        </div>

      </div>

    </div>

  </div>

</div>



<div class="overallClients">

  <div class="container">

    <div class="custom-container">
      <div class="row clientGridimages">
        <h2 class="text-uppercase text-center text-white m-0 mb-4 pb-5" data-aos="fade-up" data-aos-duration="1800">
          our growth enablers</h2>

        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/rockwell.svg" alt="rockwell">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/premierAmerica.svg" alt="premierAmerica">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/qualcomm.svg" alt="qualcomm">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/mulesoftLogo.svg" alt="mulesoft">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/init.svg" alt="init">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/codebase.svg" alt="codebase">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/oracle.svg" alt="oracle">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/paramount.svg" alt="paramount">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/citadel.svg" alt="citadel">

        </div>
        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/apaylo.svg" alt="apaylo">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/siliconLabs.svg" alt="siliconLabs">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/JHON.svg" alt="jhonDeere">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/INSIGHT.svg" alt="insight">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0">
          <img class="img-fluid" src="../../assets/images/clients/dristia.svg" alt="dristia">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>
        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/superPicks.svg" alt="superPicks">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0" data-aos="fade-down" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/sportbet.svg" alt="sportbetting">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>

        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/telsu.svg" alt="telus">
        </div>

        <div class="clientsImg px-0 clientsEmpty"> </div>
        <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
          <img class="img-fluid" src="../../assets/images/clients/win4real.svg" alt="win4real">
        </div>

        <h6 class="text-center m-0 termConditions pt-5 lh-base px-5">
          All company, product and service names of the third party companies used in this website are for
          identification purposes only. All these product names, logos and brands belong to their respective owners.
        </h6>

      </div>

    </div>

  </div>

</div>

<div class="ourculture py-5">
  <div class="container py-5">
    <div class="custom-container">
      <h6 class="text-center text-white">OUR CULTURE</h6>
      <p class="text-center pb-3">“Great things in business are never done by one person. They're done by a team of
        people.”</p>
      <!-- <p class="text-center stevJob pb-3">- Steve Jobs</p> -->
      <div class="row">
        <div class="col-lg-4">
          <img class="img-fluid cultureImg" data-aos="flip-left" data-aos-duration="2000" src="../../assets/images/culture1.jpg" alt="team">
        </div>

        <div class="col-lg-4">
          <img class="img-fluid cultureImg" data-aos="flip-up" data-aos-duration="2000" src="../../assets/images/culture2.jpg" alt="team">
        </div>

        <div class="col-lg-4">
          <img class="img-fluid cultureImg" data-aos="flip-right" data-aos-duration="2000" src="../../assets/images/culture4.jpg" alt="team">
        </div>
        <a href="#" [routerLink]="['/gallery']" class="text-decoration-none pt-3 text-end" role="button">View All</a>

      </div>
    </div>
  </div>
</div>


<div class="drivingForce">

  <div class="container">

    <div class="custom-container py-4">

      <div class="row py-5">
        <h6 class="text-center text-uppercase pb-5 text-white" data-aos="flip-right" data-aos-duration="2000">The
          Driving Force</h6>
        <div class="col-lg-6 d-flex justify-content-center rectangle1">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber1">
            <img class="img-fluid p-5" data-aos="flip-left" data-aos-duration="2200" src="../../assets/images/md.png" alt="founder"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">S. Pulla Reddy</h3>
            <p class="text-center">Founder and Managing Director</p>
          </div>
        </div>
        <div class="col-lg-6 d-flex justify-content-center rectangle2">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber2">
            <img class="img-fluid p-5" data-aos="flip-right" data-aos-duration="2300" src="../../assets/images/ed.png" alt="executiveDirector"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">Jeyaram</h3>
            <p class="text-center">Board Advisor</p>
          </div>
        </div>
        <div class="col-lg-6 d-flex justify-content-center rectangle2">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber3">
            <img class="img-fluid p-5" data-aos="flip-left" data-aos-duration="2400" src="../../assets/images/vp.png" alt="vicePresident"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">Phani Karnati</h3>
            <p class="text-center">Associate Vice President (Technology)</p>
          </div>
        </div>
        <!-- <div class="col-lg-6 d-flex justify-content-center rectangle1">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber5">
            <img class="img-fluid p-5" data-aos="flip-right" data-aos-duration="2700" src="../../assets/images/BA.png" alt="boardAdvisor"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">Srikanth Chintalapati</h3>
            <p class="text-center">Board Advisor</p>
          </div>
        </div> -->


        <!-- <div class="col-lg-6 d-flex justify-content-center rectangle1">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber6">
            <img class="img-fluid p-5" data-aos="flip-right" data-aos-duration="2700"
              src="../../assets/images/sr_pm.png" alt="technicalDirector"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">B V Devendranath</h3>
            <p class="text-center">Technical Director</p>
          </div>
        </div> -->

        <!-- <div class="col-lg-6 d-flex justify-content-center rectangle2">

          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber17">
            <img class="img-fluid p-5" data-aos="flip-left" data-aos-duration="3000"
              src="../../assets/images/satish.png" alt="agm" style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">Satish Karri</h3>
            <p class="text-center">Technical Director</p>
          </div>
        </div> -->

        <!-- <div class="col-lg-6 d-flex justify-content-center rectangle1">
          <div class="pointer" style="padding:29px" data-bs-toggle="modal" data-bs-target="#boardmemeber7">
            <img class="img-fluid p-5" data-aos="flip-right" data-aos-duration="2500" src="../../assets/images/acc_mg.png" alt="coo"
              style="border-radius: 50%;background: #7199C1;">
            <h3 class="text-center text-white">Kishore Tadepalli</h3>
            <p class="text-center">Associate Vice President (IT-Staffing)</p>
          </div>
        </div> -->

      </div>

    </div>
  </div>
</div>

<!-- <div class="py-5">
  <app-careers></app-careers>
</div> -->

<div class="">
  <app-contact-us></app-contact-us>
</div>

<!-- Pulla reddy -->

<div class="modal fade" id="boardmemeber1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">

        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/md.png" alt="founder">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Board Members</div>

            <div class="board-head font-weight-light mb-0">S. Pulla Reddy</div>

            <small class="member-designation-popup font-weight-light mt-0">Founder and Managing Director</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Mr. Pulla Reddy has over 36 years of experience in leading enterprise Software &amp; IT Services
              Industry. He is an Engineering graduate in Computer Science from Nagarjuna University (1985-1989 batch).
              He started his career with Binary Semantics and Embee Software, New Delhi. Then, he moved to Hyderabad
              in 1995 and started SP Software.
            <p class="member-designation-content">
              Mr. Pulla Reddy was awarded the Bharat Nirman Excellence Award. Recently, he received the Rashtriya
              Rattan Award for his role in the Socio-Economic Development of the company.
            </p>
            <p class="member-designation-content">
              He has a deep understanding of the organization and IT Industry. He is an expert in overseeing global
              delivery with strategic direction, nurturing customer relationships and spearheading the strategic use
              of human resources for competitive advantage.
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Jeyaram -->
<div class="modal fade" id="boardmemeber2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">


        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/ed.png" alt="executiveDirector">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Advisory Team</div>

            <div class="board-head font-weight-light mb-0">Jeyaram</div>

            <small class="member-designation-popup font-weight-light mt-0">Board Advisor</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Associated with SP Group since 1998, Jeyaram has over 33 years of experience in the Software Industry.
              As an Executive Director, he is responsible for the Global Delivery, Enterprise Quality &amp;
              Employee Productivity.
            </p>

            <p class="member-designation-content">
              He has an Engineering degree from Bangalore University, India. He oversees all
              Software Application Development, Data Analytics Solutions, ML/AI Solutions, Manufacturing Automation
              Software Development, Mobile Applications &amp; Telecom Testing.
            </p>

            <p class="member-designation-content">
              Prior to SP Group, Jeyaram has worked with the companies Kirloskar Computer Services, Rizvi
              Software Consultancy and Satyam Computers.
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Phani Karnati -->
<div class="modal fade" id="boardmemeber3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">


        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/vp.png" alt="vicePresident">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Advisory Team</div>

            <div class="board-head font-weight-light mb-0">Phani Karnati</div>

            <small class="member-designation-popup font-weight-light mt-0">Associate Vice President (Technology)</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Phani Karnati has 17+ years of experience in Technology, with more than 8+ years in Machine learning and
              Advance Artificial Intelligence technologies like Image processing and NLP
            </p>
            <p class="member-designation-content">
              Developing a product to predict the Battery State of Health (SoH), State of Charge(SoC) using the key
              battery vitals Current (C), Voltage(V) and Temperature(T).
            </p>
            <p class="member-designation-content">
              In his previous role as Lead Data Scientist, at Humana Inc a Top 5th HealthCare provider in entire North
              America, Phani has implemented solutions for complex Machine learning and Deep learning models like
              predicting Hysterectomy and Cancer cell prediction with Image processing.
            </p>



            <p class="member-designation-content">
              Developed the machine learning predictive models for employee satisfaction score card and employee
              performance score card as part of CoE contributions.
            </p>

            <p class="member-designation-content">
              Prior to this role Phani was an Analytics lead with XPO logistics where he implemented the NLP and a
              complete ware house management solution for that company. </p>

            <p class="member-designation-content">
              Phani was an Engagement lead with GE Corporate , technically leading the whole web development engagement
              from On-shore.
            </p>

            <p class="member-designation-content">
              Phani started his career with Tech Mahindra working for the client British Telecom UK in web development
              technologies and provided the cutting edge solutions.


            </p>



          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Srikanth Chintalapati -->
<!-- <div class="modal fade" id="boardmemeber5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">

        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>



        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/BA.png" alt="boardAdvisor">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Advisory Team</div>

            <div class="board-head font-weight-light mb-0">Srikanth Chintalapati</div>

            <small class="member-designation-popup font-weight-light mt-0">Board Advisor</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Srikanth has over a decade of experience in the Private Equity space, with an exceptional success rate in
              Mergers & Acquisitions. He is the founding partner of an organization that incubates and invests in
              deep-tech startups. Srikanth advises the portfolio companies in product development, scaling up of
              operations, and the go-to-market strategies.
            </p>
            <p class="member-designation-content">Srikanth has over 25 years of technology industry experience across
              various domains and verticals. In the last 15 years, he has co-founded and successfully exited technology
              ventures. Srikanth has consulted for a Venture Capital Fund in the US, following his pivotal stint at
              Aeries Technology Group as the Chief Operating Officer. At Aeries, he built a dedicated partner
              relationship with the largest legal process outsourcing firm in North America, supporting M&A transactions
              to the tune of $6B.


            </p>
            <p class="member-designation-content">Srikanth has served as an Executive Partner & Investor at CASHe
              FinTech venture, one of India's leading digital lending platforms. He cofounded Rocsys Technologies and
              Green Ark Enersol, operating in telecom and banking industries.

            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- Devendranadh -->
<!-- <div class="modal fade" id="boardmemeber6" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">

        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/sr_pm.png" alt="technicalDirector">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Divisional Manager</div>

            <div class="board-head font-weight-light mb-0">B V Devendranath</div>

            <small class="member-designation-popup font-weight-light mt-0">Technical Director</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Devendra is a passionate technocrat. In his 19 years of his career, he has worked across the spectrum of
              Information Technology which includes Product Architecture, Product Development and Application
              Development.
            </p>
            <p class="member-designation-content">
              He is an expert in defining enterprise solutions and team building/mentoring. In all his assignments, he
              has
              nurtured and honed his core technical skills. He continues to work on building innovative technology
              solutions to realize business.
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- Sathish Karri -->
<!-- <div class="modal fade" id="boardmemeber17" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">

        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/satish.png" alt="agm">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Divisional Manager</div>

            <div class="board-head font-weight-light mb-0">Satish Karri</div>

            <small class="member-designation-popup font-weight-light mt-0">Technical Director</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              Mr. Satish Karri has over 24 years of experience in Software Industry. He has been catering different
              needs of various clients across the globe and has been successfully delivering the defect-free projects
              on-time. He is responsible for validating estimates and budgets, staffing resources, mitigating risks and
              tailoring the delivery methodologies.
            </p>

            <p class="member-designation-content">
              He has proven track record of delivering world-class solutions to suit
              unique business needs of world’s top clients and led scope change management-estimation, implementation
              and
              releases, provided pre-sales support, and helped the accounts team on closures and payment realizations.
            </p>

            <p class="member-designation-content">
              He has worked with clients like Qualcomm Technologies Inc., Rockwell
              Automation Inc., MuleSoft LLC, SportsBetting.com, TELUS, Paramount Commerce, Apaylo Finance Technology
              Inc., Wipro Limited, Mahindra Satyam, Dr. Reddy's, Dr. Reddy's Foundation, ICRISAT, BSNL, Deccan
              Chronicle, Kernex Microsystems, etc.
            </p>

            <p class="member-designation-content">
              He has hands-on experience in delivering productivity through optimal
              resource utilization, code-reuse and best automated testing practices. His experience includes
              Offshore Software Project Management, Software Product Life Cycle Management, quality processes and
              procedures. He has technical expertise in Microsoft, Java, Android, iOS, IoT and Cloud technologies.
            </p>

            <p class="member-designation-content">
              He has involved in the complete cycle of implementing ISO 9001:2015,
              ISMS 27001:2013, and CMMI Level 3 and helped meeting the QA goals. He has a deep passion towards mentoring
              people, identifying right trainings, providing feedback and motivating people to meet the team
              commitments and client targets.
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- Kishore Tadepalli -->
<!-- <div div class="modal fade" id="boardmemeber7" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 12px solid #3399FF;">

        <button type="button" class="btn-close pr-2 close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3">

          <div class="col-lg-3 text-left mt-3">
            <img class="img-fluid" src="../../assets/images/acc_mg.png" alt="agm">
          </div>

          <div class="col-lg-9 text-left mt-3">

            <div class="board-semhead font-weight-bold">Divisional Manager</div>

            <div class="board-head font-weight-light mb-0">Kishore Tadepalli</div>

            <small class="member-designation-popup font-weight-light mt-0">Associate Vice President
              (IT-Staffing)</small>

            <div class="border-bottom-orange mt-3 mb-2"> </div>

            <p class="member-designation-content">
              With a stint of 13+ years in HR Services and Contingent Workforce Industry, Kishore Tadepalli has
              expertise in successfully leading and managing business units. He has a built-in ability to drive and
              deliver timely solutions for clients.
            </p>

            <p class="member-designation-content">
              At SP Soft, Kishore and his team are efficiently catering to client needs and enabling them to meet their
              business goals. They are always instrumental in driving the growth of the IT staffing business. He is
              expertly scaling up business operations in line with the company's vision.
            </p>

            <p class="member-designation-content">
              He graduated in Computer Science and Engineering from the University of Madras and has a Master's degree
              in HR Management from Pondicherry University.
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="years justify-content-end position-fixed">
  <a><img class="img-fluid pb-1" src="../../assets/images/26yearsJourney.svg" alt="spsoft"></a>
</div>

<div [innerHTML]="logoDataHTML"></div>
<div [innerHTML]="breadCrumbDataHTML"></div>